import { Font } from '@react-pdf/renderer'
import type { Style } from '@react-pdf/stylesheet'
import ManropeBold from 'assets/Manrope-Bold.ttf'
import ManropeRegular from 'assets/Manrope-Regular.ttf'

const UNICODE_FAMILY = 'Manrope'

Font.register({
  family: UNICODE_FAMILY,
  fonts: [{ src: ManropeRegular }, { src: ManropeBold, fontWeight: 'bold' }],
})

export interface PdfFontSet {
  regular: Style
  bold: Style
  italic: Style
  boldItalic: Style
  mono: Style
}

const HELVETICA: PdfFontSet = {
  regular: { fontFamily: 'Helvetica' },
  bold: { fontFamily: 'Helvetica-Bold' },
  italic: { fontFamily: 'Helvetica-Oblique' },
  boldItalic: { fontFamily: 'Helvetica-BoldOblique' },
  mono: { fontFamily: 'Courier' },
}

/**
 * Helvetica is the sheet face. Manrope covers characters outside Helvetica's
 * WinAnsi encoding (Greek, arrows, non-Latin scripts) and is used only when
 * the content needs it. It ships no italic, so italic runs stay on Helvetica.
 */
export const PDF_FONTS = {
  helvetica: HELVETICA,
  unicode: {
    ...HELVETICA,
    regular: { fontFamily: UNICODE_FAMILY },
    bold: { fontFamily: UNICODE_FAMILY, fontWeight: 'bold' },
  } satisfies PdfFontSet,
} as const

const WIN_ANSI_TEXT =
  /^[\s\u0020-\u00ff\u0152\u0153\u0160\u0161\u0178\u017d\u017e\u0192\u02c6\u02dc\u2013\u2014\u2018-\u201a\u201c-\u201e\u2020-\u2022\u2026\u2030\u2039\u203a\u20ac\u2122]*$/

export function needsUnicodeFont(text: string): boolean {
  return !WIN_ANSI_TEXT.test(text)
}

export function pdfFontsFor(text: string): PdfFontSet {
  return needsUnicodeFont(text) ? PDF_FONTS.unicode : PDF_FONTS.helvetica
}
